import type { ExtractPropTypes } from 'vue'

export interface TimelineEvent {
  status?: string
  date?: string
  icon?: string
  color?: string
  image?: string
  content: string
}

export const timelineProps = {
  /**
   * An array of events to display
   */
  value: {
    type: Array as () => TimelineEvent[],
    required: true
  },
  /**
   * Position of the timeline bar relative to the content. Valid values are "left", "right", "alternate", "top", "bottom"
   */
  align: {
    type: String,
    default: 'left',
    validator: (value: string) => ['left', 'right', 'alternate', 'top', 'bottom'].includes(value)
  },
  /**
   * Layout orientation of the timeline, valid values are "vertical" and "horizontal"
   */
  layout: {
    type: String,
    default: 'vertical',
    validator: (value: string) => ['vertical', 'horizontal'].includes(value)
  },
  /**
   * Whether to show the marker or not
   */
  marker: {
    type: Boolean,
    default: true
  }
} as const

export type TimelineProps = ExtractPropTypes<typeof timelineProps>
